import Hoadministration from "./Hoadministration";
import Employeeadministration from "./Employeeadministration";
import Master from "./Master";
import Reportparameters from "./Reportparameters";
import Loanmaster from "./Loanmaster";
import Agriloanmaster from "./Agriloanmaster"
import Ledger from "./Ledger";
import  Productmaster from "./Productmaster";


export default {
    ...Hoadministration,
    ...Employeeadministration,
    ...Master,
    ...Reportparameters,
    ...Loanmaster,
    ...Agriloanmaster,
    ...Ledger,
    ...Productmaster
   
}